import React from 'react';
import heroMobile from "../Assets/images/mobilep2.png"


const SectionSeven = () => {


    return(

            <div className='flex flex-col lg:flex-row  lg:items-end justify-center lg:mx-auto lg:w-maxWidth w-full pt-24 pb-24  lg:pt-24 gap-10 lg:gap-0 mx-auto'>
                <div className="w-full lg:p-0  p-4  lg:w-2/4 flex flex-col gap-5 ">
                    <h2 className="font-axiforma text-2xl lg:text-4xl font-light text-primary ">Accept your <b className="font-bold">payments online,</b>even if your <b className="font-bold">business is offline</b></h2>
                    <p className=" font-axiforma text-secondary text-lg">
                        If you’re running a retail store without a POS machine, with the PayPro Business App you can easily generate and share instant payment links, along with a QR code for each invoice. Your customers can easily scan the code to make selfservice payments at point of sale, and you get to accept card payments without disappointing your walk-in customers
                    </p>
                </div>
                <div className="w-full  lg:w-2/4 flex items-center  justify-center ">
                    <img className=" w-2/4  md:w-2/6 lg:w-2/4 " src={heroMobile} alt={heroMobile} />
                </div>
            </div>

    );
}

export  default SectionSeven